<template>
  <div class="ring-box">
    <!-- 饼图 -->
    <div id="ring" v-show="ispie && userLevel > 1"></div>
    <!-- 统计区 -->
    <div class="content" v-if="!ispie && statisticals">
      <div class="flex-1">
        <div class="title">
          <div>共享自行车</div>
          <div>
            <span>投放总量：{{ statisticals.bikeNum }}</span>
            <span class="pr10">站点车辆：{{ statisticals.bSiteNumTotal }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-1">
            <template
              v-if="statisticals && statisticals.bike && statisticals.bike.length"
            >
              <div
                class="num"
                v-for="(item, index) in statisticals.bike"
                :key="'bike' + index"
              >
                <span class="gray-a">{{ item && item.brandName }}：</span>
                <span class="gray-a">{{ item.onlineNum }}</span>
                <span
                  v-show="item.onlineNum && item.brandEBikeNum"
                  :class="{
                    red: item.onlineNum / item.brandBikeNum > 1,
                    blue: item.onlineNum / item.brandBikeNum <= 1,
                  }"
                  >{{
                    item.brandBikeNum
                      ? parseInt(
                          Math.floor(
                            Number(item.onlineNum / item.brandBikeNum) *
                              100 *
                              100
                          ) / 100
                        )
                      : 0
                  }}%</span
                >
                <span class="gray-a">{{ item.siteNum }}</span>
                <span @click="filterBike(item.brandId, 0)">查看</span>
              </div>
            </template>
            <template v-else>
              <div class="gray-a" style="margin-bottom: 15px">暂无数据</div>
            </template>
          </div>
        </div>
      </div>
      <div class="flex-1">
        <div class="title">
          <div>共享电动车</div>
          <div>
            <span>投放总量：{{ statisticals.ebikeNum }}</span>
            <span class="pr10">站点车辆：{{ statisticals.eSiteNumTotal }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-1">
            <template
              v-if="
                statisticals && statisticals.ebike && statisticals.ebike.length
              "
            >
              <div
                class="num"
                v-for="(item, index) in statisticals.ebike"
                :key="'ebike' + index"
              >
                <span class="gray-a">{{ item && item.brandName }}：</span>
                <span class="gray-a">{{ item.onlineNum }}</span>
                <span
                  v-show="item.onlineNum && item.brandEBikeNum"
                  :class="{
                    red: item.onlineNum / item.brandEBikeNum > 1,
                    blue: item.onlineNum / item.brandEBikeNum <= 1,
                  }"
                  >{{
                    item.brandEBikeNum
                      ? parseInt(
                          Math.floor(
                            Number(item.onlineNum / item.brandEBikeNum) *
                              100 *
                              100
                          ) / 100
                        )
                      : 0
                  }}%</span
                >
                <span class="gray-a">{{ item.siteNum }}</span>
                <span @click="filterBike(item.brandId, 1)">查看</span>
              </div>
            </template>
            <template v-else>
              <div class="gray-a" style="margin-bottom: 15px">暂无数据</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart, registerShape } from '@antv/g2'
import Api from '@/api'
import { mapGetters } from 'vuex'
import { log } from '@antv/g2plot/lib/utils'

export default {
  name: 'TotalRingChart',
  data() {
    return {
      Circle1: null,
      realNames: [],
      timer: null,
      cData: [],
      onlineTotal: 0,
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {}
    }
  },
  computed: {
    ...mapGetters(['userLevel']),
    statisticals() {
      const arr = this.statistical
      if (arr.bike && arr.bike.length > 0) {
        arr.bike = arr.bike
          .filter((val) => val.onlineNum)
          .map((val) => {
            val.brandName = val.brandName.slice(0, 2) + '单车'
            return val
          })
      }
      if (arr.ebike && arr.ebike.length > 0) {
        arr.ebike = arr.ebike.filter((val) => val.onlineNum)
      }
      return arr
    }
  },
  props: {
    ispie: {
      type: Boolean,
      default: true
    },
    statistical: {
      type: Object,
      default() {
        return {}
      }
    },
    selfAreaId: {
      default: '',
      type: String
    }
  },
  watch: {
    selfAreaId(v, o) {
      this.getAreaBrandDetails()
        .then(() => {
          this.initCircle1Data()
        })
    },
    ispie(v) {
      if (v) {
        this.$nextTick(() => {
          this.getAreaBrandDetails()
          setTimeout(() => {
            this.initCircle1(this.cData, this.onlineTotal)
          }, 1000)
        })
      }
    }
  },
  mounted() {
    this.getAreaBrandDetails()
      .then(() => {
        this.initCircle1Data()
      })
  },
  created() {
    this.getAreaBrandDetails()
  },
  methods: {
    initCircle1(cData, total) {
      const vm = this
      // 可以通过调整这个数值控制分割空白处的间距，0-1 之间的数值
      const sliceNumber = 0.002
      // // 自定义 other 的图形，增加两条线
      registerShape('interval', 'slice-shape', {
        draw(cfg, container) {
          const points = cfg.points
          let path = []
          path.push(['M', points[0].x, points[0].y])
          path.push(['L', points[1].x, points[1].y - sliceNumber])
          path.push(['L', points[2].x, points[2].y - sliceNumber])
          path.push(['L', points[3].x, points[3].y])
          path.push('Z')
          path = this.parsePath(path)
          return container.addShape('path', {
            attrs: {
              fill: cfg.color,
              path
            }
          })
        }
      })
      if (vm.Circle1) {
        vm.Circle1.destroy()
      }
      vm.Circle1 = new Chart({
        container: 'ring',
        autoFit: true
      })
      // 颜色指定
      const colorArr = this.getColorsByNames()
      console.log(colorArr, 111)
      colorArr.push('#F5F5F5')
      colorArr.push('#D9D9D9')
      vm.Circle1.data(cData)
      vm.Circle1.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.6
      })
      vm.Circle1.legend({
        flipPage: false,
        itemName: {
          style: {
            fill: '#00DADA'
          }
        }
      })
      vm.Circle1.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: `<li class="g2-tooltip-list-item" style='background:transparent'><span style="background-color:{color};" class="g2-tooltip-marker"></span>
            <span style="font-weight:bold;" class='{color}'>{name}: {percent}%</span>
            <p style="margin-top:10px;margin-left:20px;">在线量{online}辆</p>
            <p style="margin-top:10px;margin-left:20px;">核定量{setCount}辆</p>
            <p style="margin-top:10px;margin-left:20px;color:#00DADA;text-decoration: underline;" >站点车辆{inSite}辆</p>
          </li>`
      })
      // 辅助文本
      vm.Circle1.annotation()
        .text({
          position: ['50%', '50%'],
          content: total,
          style: {
            fontSize: 26,
            lineWidth: 0.1,
            fill: '#fff',
            textAlign: 'center'
          },
          offsetY: -10
        })
        .text({
          position: ['50%', '50%'],
          content: '总在线量',
          style: {
            fontSize: 14,
            fill: '#fff',
            lineWidth: 0.1,
            textAlign: 'center'
          },
          offsetX: 0,
          offsetY: 10
        })
      vm.Circle1.interval()
        .style({
          stroke: 'white',
          lineWidth: 1
        })
        .adjust('stack')
        .position('bili')
        .color('type', colorArr)
        .tooltip(
          'type*bili*percent*online*inSite*setCount',
          (type, bili, percent, online, inSite, setCount) => {
            return {
              name: type,
              bili,
              percent,
              online,
              inSite,
              setCount,
              color: percent > 100 ? 'red' : 'white'
            }
          }
        )
        .shape('slice-shape')

      vm.Circle1.render()
    },
    async getAreaBrandDetails() {
      this.brandOriginColor = {}
      this.eOriginColor = {}
      if (this.selfAreaId !== '') {
        try {
          const params = {
            selfAreaId: this.selfAreaId
          }
          await Api.areaBrandDetails(params).then((res) => {
            if (res.code === 200) {
              const brandOriginColor = res.data.map(item => {
                return {
                  brandName: item.brandName.slice(0, 2) + '单车',
                  bikeColor: item.bikeColor
                }
              })
              // 单车
              const colorObject = brandOriginColor => {
                for (let i = 0; i < brandOriginColor.length; i++) {
                  const { brandName, bikeColor } = brandOriginColor[i]
                  this.brandOriginColor[brandName] = bikeColor
                }
                return this.brandOriginColor
              }
              this.brandOriginColor = colorObject(brandOriginColor)
              // 电动车
              const eBrandOriginColor = res.data.map(item => {
                if (item.brandName.indexOf('美团出行') > -1) {
                  return {
                    brandName: '美团电单',
                    eBikeColor: item.ebikeColor
                  }
                }
                return {
                  brandName: item.brandName,
                  eBikeColor: item.ebikeColor
                }
              })
              const eColorObject = eBrandOriginColor => {
                for (let i = 0; i < eBrandOriginColor.length; i++) {
                  const { brandName, eBikeColor } = eBrandOriginColor[i]
                  this.eOriginColor[brandName] = eBikeColor
                }
                return this.eOriginColor
              }
              this.eOriginColor = eColorObject(eBrandOriginColor)
            } else {
              console.log('汇总区域品牌信息为空 -TotalRingChart')
            }
          })
        } catch (e) {
          this.eOriginColor = {}
          this.brandOriginColor = {}
        }
      }
    },
    // 自行车品牌颜色
    originColor(name) {
      return this.brandOriginColor[name]
    },
    // 电动车品牌颜色
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames() {
      const arr = []
      for (let i = 0, len = this.realNames.length; i < len; i++) {
        const item = this.realNames[i]
        if (item.indexOf('单车') !== -1) {
          arr.push(this.originColor(item) ? this.originColor(item) : this.color16())
        } else {
          arr.push(this.eBrandOriginColor(item) ? this.eBrandOriginColor(item) : this.color16())
        }
      }
      return arr.filter((v) => v)
    },
    async initCircle1Data() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (!this.selfAreaId || this.userLevel < 2) {
        this.initCircle1([], 0)
        return
      }
      const params = {
        selfAreaId: this.selfAreaId
      }
      await Api.brandPercentNew(params).then((res) => {
        if (res.code === 200) {
          delete res.data.areaBikeNum
          delete res.data.areaEleBikeNum
          this.pinpaiSort = Object.keys(res.data || {})
          const tableData = this.translateData2(res.data)
          const cData = []
          const onlineTotal = Object.values(tableData).reduce((per, cur) => {
            per += cur.PutBikeNum
            per += cur.PutEBikeNum
            return per
          }, 0) //  总在线量
          let setCountTotal = 0
          this.realNames = []
          for (const key in tableData) {
            if (!tableData[key]) {
              continue
            }
            // 保留原始数据
            tableData[key].PutBikeNumOrigin = tableData[key].PutBikeNum
            tableData[key].PutEBikeNumOrigin = tableData[key].PutEBikeNum
            // 数据修正
            tableData[key].PutBikeNum =
              tableData[key].PutBikeNum <= tableData[key].BrandBikeNum
                ? tableData[key].PutBikeNum
                : tableData[key].BrandBikeNum
            tableData[key].PutEBikeNum =
              tableData[key].PutEBikeNum <= tableData[key].BrandEBikeNum
                ? tableData[key].PutEBikeNum
                : tableData[key].BrandEBikeNum
            // 总核定量
            setCountTotal += tableData[key].BrandEBikeNum
            setCountTotal += tableData[key].BrandBikeNum
            const curData = tableData[key]
            // 单车数据集
            const tempBike = {
              type: this.getPinPaiName(key, 1), // key + '(单车)',
              key: 1,
              bili: this.getValue(
                // 在线量占比
                curData.PutBikeNumOrigin,
                onlineTotal
              ),
              percent: this.getValue(
                curData.PutBikeNumOrigin,
                curData.BrandBikeNum
              ),
              online: curData.PutBikeNumOrigin,
              inSite: curData.SiteBikeNum,
              setCount: curData.BrandBikeNum
            }
            // 电车数据集
            const tempEBike = {
              type: this.getPinPaiName(key, 2), // key + '(电动车)',
              key: 2,
              bili: this.getValue(
                // 在线量占比
                curData.PutEBikeNumOrigin,
                onlineTotal
              ),
              percent: this.getValue(
                // 在线量占比
                curData.PutEBikeNumOrigin,
                curData.BrandEBikeNum
              ),
              online: curData.PutEBikeNumOrigin,
              inSite: curData.SiteEBikeNum,
              setCount: curData.BrandEBikeNum
            }
            if (tempBike.online + tempBike.setCount > 0) {
              cData.push(tempBike)
              this.realNames.push(this.getPinPaiName(key, 2))
            }
            if (tempEBike.online + tempEBike.setCount > 0) {
              cData.push(tempEBike)
              this.realNames.push(this.getPinPaiName(key, 1))
            }
          }
          this.timer = setTimeout(this.initCircle1Data, 180000) // 3分钟
          try {
            this.initCircle1(cData, onlineTotal)
            this.cData = cData
            this.onlineTotal = onlineTotal
            // 在此运行代码
          } catch (err) {
            // 在此处理错误
            console.log('c3', err)
          }
        } else {
          this.initCircle1([], 0)
          console.log('品牌占比统计数据为空 - TotalRingChart')
        }
      })
    },
    getPinPaiName(originName, type) {
      // originName - 品牌原名，key：1-自行车，2-电动车
      if (type === 1) {
        return originName.slice(1).slice(0, 2) + '单车'
      } else if (type === 2) {
        if (originName.indexOf('美团出行') > -1) {
          return '美团电单'
        }
        return originName.slice(1)
      }
    },
    getValue(n, total) {
      if (n === 0 || total === 0) {
        return 0
      }
      return Number((Number(Number(n / total).toFixed(3)) * 100).toFixed(1))
    },
    translateData2(data) {
      let i = 1
      const pSort = {}
      for (const key of this.pinpaiSort) {
        pSort[i + key] = data[key]
        i++
      }
      return pSort
    },
    dashboardBike(legality) {
      this.$emit('dashboardBike', legality)
    },
    filterBike(brandId, bikeType) {
      if (brandId) {
        this.$emit('filterBike', {
          brandId,
          bikeType
        })
      } else {
        console.log(22222)
        this.$emit('filterBike', false)
      }
    },
    showModel(item, type, bikeType) {
      // type 1-企业，2-查看
      const params = {
        ...item,
        type,
        bikeType
      }
      this.$emit('showModel', params)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    if (!this.Circle1) return
    this.Circle1.destroy()
    this.Circle1 = null
  }
}
</script>

<style scoped lang='less'>
.ring-box {
  display: flex;
  position: relative;
  height: 100%;
  overflow: auto;
  #ring {
    flex: 1;
  }
  .ring {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

/deep/.g2-tooltip {
  background: #021922 !important;
  box-shadow: 0px 0px 8px 0px rgba(0, 218, 218, 0.3) !important;
  .g2-tooltip-list {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    .red {
      color: #ed462f;
    }
  }
}

.content {
  overflow: auto;
  flex: 1;
  display: flex;
  color: #00dada;
  .flex {
    display: flex;
    justify-content: space-between;
  }
  > .flex-1 {
    padding: 0 10px;
  }
  .flex-1 {
    flex: 1;
    .title {
      margin-top: 16px;
      margin-bottom: 16px;
      > div:first-child {
        margin-bottom: 16px;
        font-size: 14px;
        text-align: center;
        & + div {
          display: flex;
          justify-content: space-between;
        }
      }
      > div:last-child {
        span:first-child {
          cursor: pointer;
        }
      }
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      line-height: 14px;
    }
    .num {
      margin-bottom: 10px;
      font-size: 12px;
      display: flex;
      justify-content: space-around;
      line-height: 12px;
      span {
        flex: 1;
        text-align: left;
        &:first-child {
          flex: 0 0 5em;
        }
        // &:nth-child(2) {
        //   cursor: pointer;
        // }
        &:nth-child(4) {
          text-align: right;
        }
        &:last-child {
          flex: 0 0 2em;
          margin-left: 1em;
          cursor: pointer;
        }
      }
      .gray-a {
        color: rgba(255, 255, 255, 0.65);
      }
      .blue {
        color: #1f8ffb;
      }
      .red {
        color: #ed462f;
        margin-right: 8px;
      }
    }
  }
}
</style>
